/** 「回答しない」を表すマスタ上のコード。本人の選択でのみ使い、自動推定では選ばない。 */
export const UNKNOWN_REGION_CODE = 'UNKNOWN';

interface EstimateCountryInput {
  /** /geo の結果。取得できなかった場合は null。 */
  geoCountry: string | null;
  /** navigator.languages */
  languages: readonly string[];
  /** 地域マスタのコード一覧 */
  regionCodes: ReadonlySet<string>;
}

/**
 * 居住地の初期値を推定する。推定できなければ null (未選択のまま)。
 *
 * 優先順位は IP (geo) → ロケール。ロケールは en-US を既定にしている非米国の利用者が
 * 多く誤推定しやすいため、IP が取れなかったときの補助にとどめる。
 */
export function estimateCountry({
  geoCountry,
  languages,
  regionCodes,
}: EstimateCountryInput): string | null {
  const isSelectable = (code: string | null): code is string =>
    code !== null && code !== UNKNOWN_REGION_CODE && regionCodes.has(code);

  if (isSelectable(geoCountry)) {
    return geoCountry;
  }
  for (const tag of languages) {
    const region = explicitRegionOf(tag);
    if (isSelectable(region)) {
      return region;
    }
  }
  return null;
}

/**
 * タグに明示された地域サブタグを返す ("en-GB" → "GB"、"en" → null)。
 * Intl.Locale#maximize による補完はしない。"en" が "US" になり誤推定の主因になるため。
 */
function explicitRegionOf(tag: string): string | null {
  try {
    return new Intl.Locale(tag).region ?? null;
  } catch {
    // 不正な言語タグは推定材料にならないだけなので、次のタグへ進む
    return null;
  }
}
